import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91e97190"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "highformwork-container" }
const _hoisted_2 = { class: "card-1" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "tr1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "监测时间：", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "tr2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "监测时长：", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "card-float" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "监测点数量", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "超出预警值数量", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "超出超警值数量", -1))
const _hoisted_15 = { class: "middle-text" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "监测信息", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "list" }
const _hoisted_20 = {
  key: 0,
  class: "normal"
}
const _hoisted_21 = {
  key: 1,
  class: "outline"
}
const _hoisted_22 = {
  key: 2,
  class: "warning"
}
const _hoisted_23 = {
  key: 3,
  class: "danger"
}
const _hoisted_24 = { class: "normal1" }
const _hoisted_25 = { class: "outline1" }
const _hoisted_26 = { class: "warning1" }
const _hoisted_27 = { class: "danger1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "类型：", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实时变化值：", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预警值：", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报警值：", -1))
const _hoisted_32 = { class: "jiazai" }
const _hoisted_33 = {
  key: 0,
  class: "bottom-text"
}
const _hoisted_34 = {
  key: 1,
  class: "bottom-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.aProgramList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.aProgramList.programName), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无数据")),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (_ctx.aProgramList)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.aProgramList.startTime), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        (_ctx.aProgramList)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.aProgramList.betweenTime), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.aProgramList)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass([{
          _yes: _ctx.aProgramList.status === 2,
          _resove: _ctx.aProgramList.status === 0,
          _nodeal: _ctx.aProgramList.status === 1,
        }, "tag"])
          }, _toDisplayString(_ctx.aProgramList.status === 0
            ? "监测中"
            : _ctx.aProgramList.status === 1
            ? "已暂停"
            : "已完成"), 3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_12,
            _createElementVNode("div", null, _toDisplayString(_ctx.oCountProgram.devs ? _ctx.oCountProgram.devs : 0), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_13,
            _createElementVNode("div", null, _toDisplayString(_ctx.oCountProgram.warn ? _ctx.oCountProgram.warn : 0), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_14,
            _createElementVNode("div", null, _toDisplayString(_ctx.oCountProgram.alarm ? _ctx.oCountProgram.alarm : 0), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      (_ctx.aProgramList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.aProgramList.programName) + " ", 1),
            _createElementVNode("img", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args))),
              src: require('./images/xiala.png')
            }, null, 8, _hoisted_18),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args)))
            }, "切换")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordslist, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "listdata"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(item.devNo), 1),
                _createElementVNode("div", null, [
                  (item.devStatus === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                    : _createCommentVNode("", true),
                  (item.devStatus === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                    : _createCommentVNode("", true),
                  (item.devStatus === 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23)),
                  _withDirectives(_createElementVNode("span", _hoisted_24, "在线", 512), [
                    [_vShow, item.devStatus === 1]
                  ]),
                  _withDirectives(_createElementVNode("span", _hoisted_25, "离线", 512), [
                    [_vShow, item.devStatus === 0]
                  ]),
                  _withDirectives(_createElementVNode("span", _hoisted_26, "预警", 512), [
                    [_vShow, item.devStatus === 2]
                  ]),
                  _withDirectives(_createElementVNode("span", _hoisted_27, "报警", 512), [
                    [_vShow, item.devStatus === 3]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _hoisted_28,
                  _createElementVNode("span", null, _toDisplayString(item.type), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_29,
                  _createElementVNode("span", null, _toDisplayString(item.diffValue), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _hoisted_30,
                  _createElementVNode("span", null, _toDisplayString(item.warnValue), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_31,
                  _createElementVNode("span", null, _toDisplayString(item.alarmValue), 1)
                ])
              ])
            ]))
          }), 128)),
          _withDirectives(_createElementVNode("div", _hoisted_32, "加载中....", 512), [
            [_vShow, _ctx.refreshing]
          ]),
          (_ctx.recordslist.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, "到底了~~"))
            : (_openBlock(), _createElementBlock("div", _hoisted_34, "暂无数据"))
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.resultPicker,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.resultPicker) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: _ctx.resultPickerscolumns,
          "show-toolbar": "",
          "value-key": "name",
          onConfirm: _ctx.resultPickersonConfirm,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resultPicker = false))
        }, null, 8, ["columns", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}